import qs from 'query-string'

/* Config */
import appConfig from '../../appConfig'

function hydraHomePageComponentsApiFactory(storefrontApiClient) {
  const hydraHomePageComponents = {
    async getHydraHomePageComponents(params) {
      const {jwt, userInfo, anonymousId, viewId, forceNonLazy, ...queryParams} = params
      const cookieValue = encodeURIComponent(JSON.stringify(userInfo));
      const cookieString = `userInfo=${cookieValue}`;
      const req = storefrontApiClient.get(`${appConfig.hydraHomepageUrl}/api/v1/home/web/view/${viewId ? viewId : 'web_homepage'}?${qs.stringify(queryParams)}`, {
        withCredentials: true,
        ...params,
        headers: {
          'X-Platform': 'web',
          'X-Anonymous-Id': anonymousId ?? null,
          'X-Jwt': jwt ?? null,
          ...userInfo && {Cookie: cookieString},
          ...forceNonLazy && {'X-Force-To-Nonlazy': forceNonLazy}
        },
      })
      return req
    },
    getHydraHomePageLazyComponents(params) {
      const {jwt, userInfo, anonymousId, componentKey, ...queryParams} = params
      const cookieValue = encodeURIComponent(JSON.stringify(userInfo));
      const cookieString = `userInfo=${cookieValue}`;
      const lazyreq = storefrontApiClient.get(`${appConfig.hydraHomepageUrl}/api/v1/home/web/view/${params?.viewId ? params.viewId : 'web_homepage'}/${componentKey}?${qs.stringify(queryParams)}`, {
        withCredentials: true,
        ...params,
        headers: {
          'X-Platform': 'web',
          'X-Anonymous-Id': anonymousId ?? null,
          'X-Jwt': jwt ?? null,
          ...userInfo && {Cookie: cookieString},
        },
      })
      return lazyreq
    },
    getHydraHomePageMobileComponents(params) {
      const {jwt, userInfo, anonymousId, viewId, forceNonLazy, ...queryParams} = params
      const cookieValue = encodeURIComponent(JSON.stringify(userInfo));
      const cookieString = `userInfo=${cookieValue}`;
      const req = storefrontApiClient.get(`${appConfig.hydraHomepageUrl}/api/v1/home/mobileweb/view/${viewId ? viewId : 'mweb_homepage'}?${qs.stringify(queryParams)}`, {
        ...params,
        headers: {
          'X-Platform': 'mobileweb',
          'X-Anonymous-Id': anonymousId ?? null,
          'X-Jwt': jwt ?? null,
          ...userInfo && {Cookie: cookieString},
          ...forceNonLazy && {'X-Force-To-Nonlazy': forceNonLazy}
        },
        withCredentials: true
      })
      return req
    },
    getHydraHomePageMobileLazyComponent(params) {
      return storefrontApiClient.get(`${appConfig.hydraHomepageUrl}/api/v1/home/mobileweb${params?.url}`, {
        ...params,
        withCredentials: true
      })
    }
  }

  return hydraHomePageComponents
}

export default hydraHomePageComponentsApiFactory
